import {Injectable} from '@angular/core';
import {Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {Construct} from 'classes/construct';
import {environment} from 'environment';

@Injectable()
export class ConstructsOverviewRepository {

  constructor(private http: Http) { }

  public getAllConstructs(light: boolean): Observable<Array<Construct>> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
    });

    if (light) {
      return this.http.get(environment.constructs + '?type=light', options)
        .map((response: Response) => {
          return response.json();
        })
        .map((rawConstructs: Array<Construct>) => {
          return this.mapToConstructsLight(rawConstructs);
        });
    }

    return this.http.get(environment.constructs, options)
      .map((response: Response) => {
        return response.json();
      })
      .map((rawConstructs: Array<Construct>) => {
        return this.mapToConstructs(rawConstructs);
      });

  }

  public getConstructById(id: number): Observable<Construct> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});
    return this.http.get(`${environment.constructs}/${id}`, options)
      .map((response: Response) => {
        return response.json();
      })
      .map((rawConstruct: Construct) => {
        return Construct.create(rawConstruct);
      });
  }

  public deleteConstruct(id: number): Observable<Response> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
    });

    return this.http.delete(`${environment.constructs}/${id}`, options);
  }

  private mapToConstructsLight(rawConstructs: Array<Construct>): Array<Construct> {
    return rawConstructs.map((rawConstruct) => {
      return Construct.createLight(rawConstruct);
    });
  }
  private mapToConstructs(rawConstructs: Array<Construct>): Array<Construct> {
    return rawConstructs.map((rawConstruct) => {
      return Construct.create(rawConstruct);
    });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/constructs/constructs-overview/repositories/constructs-overview.repository.ts